import { COLORS } from "../../../../common/constants";

const styles = {
  formControl: {
    ".MuiSelect-icon": {
      color: "#E5063E",
    },
    "&.MuiInputBase-formControl": {
      border: "none",
      color: "#181B20",
      font: "normal normal 500 14px/24px mreavesxlsanot-reg",
      alignItems: "center",
      display: "flex",
      height: "53.13px",
      padding: "13.57px 0",
      "& fieldset": {
        borderRadius: "12px",
        borderColor: COLORS.black,
      },
      "&:hover fieldset": {
        borderColor: COLORS.borderGrey,
      },
      "&.Mui-disabled:hover fieldset": {
        borderColor: "rgba(0, 0, 0, 0.26)",
      },
      "& .MuiSelect-select::placeholder fieldset": {
        borderColor: "#eee",
        color: "#9da3a4",
        letterSpacing: "0.59px",
        font: "normal normal 400 14px / 22px 'mreavesxlsanot-reg'",
        opacity: "0.9 !important",
        fontSize: "14px",
      },
      "&.Mui-focused fieldset": {
        border: "1px solidrgba(24, 27, 32, 0.57)",
      },
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #FF5F30 !important",
    },
  },
  formControlBlue: {
    "& .MuiInputBase-formControl": {
      border: "none",
      color: "#181B20",
      alignItems: "center",
      display: "flex",
      height: "53.13px",
      borderColor: COLORS.primaryBlue,
      font: "normal normal 500 14px/16px mreavesxlsanot-reg",
      "&::placeholder": {
        color: "#eee",
        letterSpacing: "0.59px",
        Opacity: "40%",
        font: "normal normal 500 14px/16px mreavesxlsanot-reg",
      },
      "&:-internal-autofill-selected": {
        backgroundColor: "transparent",
      },
      "& fieldset": {
        borderRadius: "12px",
        borderColor: COLORS.primaryBlue,
      },

      "& svg": {
        fill: COLORS.error,
      },
      "&:hover fieldset": {
        borderColor: COLORS.primaryBlue,
      },
      ".Mui-focused": {
        border: "1px solidrgba(24, 27, 32, 0.57)",
      },
      "&.Mui-disabled:hover fieldset": {
        borderColor: COLORS.primaryBlue,
      },
      "& .MuiSelect-select::placeholder fieldset": {
        borderColor: COLORS.primaryBlue,
      },
      "&.Mui-focused fieldset": {
        borderWidth: "1px",
        borderColor: COLORS.primaryBlue,
      },
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      border: "1px solid#2061A8",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      font: "normal normal 500 14px/16px mreavesxlsanot-reg",
      backgroundColor: "#fff",
    },
  },
  select: {
    "& .search-item.Mui-selected": {
      background: "white",
    },
    "& .search-item.Mui-focusVisible": {
      background: "white",
    },
    "& .search-item.Mui-selected:hover": {
      background: "white",
    },
  },
  menuItem: {
    color: "#181B20",
    font: "normal normal 500 16px/16px mreavesxlsanot-reg",
    padding: "12px",
    maxHeight: "300px",
  },
  paper: {
    maxHeight: "175px",
  },
  errorTooltip: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
    color: "#FF5F30 !important",
    font: "normal normal 500 16px/16px mreavesxlsanot-reg",
  },
  label: {
    font: "normal normal 500 16px/14px mreavesxlsanot-reg",
    letterSpacing: "0.59px",
    transition: "ease-in 0.5s",
    color: COLORS.inputHead,
    marginBottom: "10px",
  },
  none: {
    visibility: "hidden",
  },
  errorIcon: {
    color: `${COLORS.themeError} !important`,
    right: "26px !important",
  },
  searchBox: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    background: "white",
    borderRadius: "6px",
    border: "1px solid #000000",
    justifyContent: "space-between",
    "& img": {
      height: "25px",
      width: "60px",
    },
  },
  searchInput: {
    width: "100%",
    height: "42px",
    border: "none",
    outline: "none",
    cursor: "pointer",
    borderRadius: "6px",
    fontSize: "16px",
    font: "normal normal 400 16px/18px mreavesxlsanot-reg",
  },
  clearIcon: {
    marginRight: "4px",
  },
};

export default styles;
